export default __webpack_public_path__ + "static/media/blockchain.b3fc6a10.png";